module.exports = __webpack_public_path__ + "img/日本支部.6236ddba.jpg";